"use strict";
/**
 * KILT enables top-down trust structures.
 * On the lowest level, a delegation structure is always a **tree**.
 * The root of this tree is DelegationRootNode.
 *
 * Apart from inheriting [[DelegationBaseNode]]'s structure, a DelegationRootNode has a [[cTypeHash]] property that refers to a specific [[CType]].
 * A DelegationRootNode is written on-chain, and can be queried by delegationId via the [[query]] method.
 *
 * @packageDocumentation
 * @module DelegationRootNode
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const config_1 = require("@kiltprotocol/config");
const Delegation_1 = tslib_1.__importDefault(require("./Delegation"));
const DelegationNode_chain_1 = require("./DelegationNode.chain");
const DelegationRootNode_chain_1 = require("./DelegationRootNode.chain");
const DelegationRootNode_utils_1 = tslib_1.__importDefault(require("./DelegationRootNode.utils"));
const log = config_1.ConfigService.LoggingFactory.getLogger('DelegationRootNode');
class DelegationRootNode extends Delegation_1.default {
    /**
     * Creates a new [DelegationRootNode].
     *
     * @param delegationRootNodeInput - The base object from which to create the delegation base node.
     */
    constructor(delegationRootNodeInput) {
        super(delegationRootNodeInput);
        this.cTypeHash = delegationRootNodeInput.cTypeHash;
        DelegationRootNode_utils_1.default(this);
    }
    /**
     * [STATIC] Queries the delegation root with ``delegationId``.
     *
     * @param delegationId Unique identifier of the delegation root.
     * @returns Promise containing [[DelegationRootNode]] or [null].
     */
    static async query(delegationId) {
        log.info(`:: query('${delegationId}')`);
        const result = await DelegationRootNode_chain_1.query(delegationId);
        if (result) {
            log.info(`result: ${JSON.stringify(result)}`);
        }
        else {
            log.info(`root node not found`);
        }
        return result;
    }
    getRoot() {
        return Promise.resolve(this);
    }
    /* eslint-disable class-methods-use-this */
    getParent() {
        return Promise.resolve(null);
    }
    /* eslint-enable class-methods-use-this */
    /**
     * Stores the delegation root node on chain.
     *
     * @returns Promise containing the unsigned SubmittableExtrinsic.
     */
    async store() {
        log.debug(`:: store(${this.id})`);
        return DelegationRootNode_chain_1.store(this);
    }
    async verify() {
        const node = await DelegationRootNode_chain_1.query(this.id);
        return node !== null && !node.revoked;
    }
    async revoke() {
        const childCount = await this.subtreeNodeCount();
        log.debug(`:: revoke(${this.id})`);
        return DelegationRootNode_chain_1.revoke(this, childCount + 1);
    }
    async getChildren() {
        return DelegationNode_chain_1.getChildren(this.id);
    }
}
exports.default = DelegationRootNode;
